import React, { useEffect, useState } from 'react'
import { Divider } from '@mui/material'
import { cn, formatDate, formatDistToNow } from '../../lib/utils'
import { IoCloseCircleOutline, IoWarningOutline } from 'react-icons/io5'
import * as Endpoints from '../../Entities/EndPoints'
import { useCommonStore } from 'src/Common/store/CommonStore'
import { useNavigate } from 'react-router'
import Drawer from '@mui/material/Drawer'
import PropTypes from 'prop-types' // Import PropTypes
import * as RoutePath from '../../Entities/RoutePath'
import { INITIATE } from 'src/Entities/CommonEntities'
import { useCompStore } from '../Governance/Store/ComplianceStore'
import ReassignDialog from 'src/Containers/Compliance/Reassign/ReassignDialog'

import Axios from 'src/Axios'
import { useLoginStore } from 'src/Containers/Auth/Store/Store'
import GovernanceNavIcon from 'src/Common/Icon/GovernanceNavIcon'
import ComplainceNavIcon from 'src/Common/Icon/ComplainceNavIcon'
import { ISSUE_TAB } from 'src/Entities/IssueTypes'
import { getAllNotification } from 'src/API/CommonAPI'
const Notification = ({ notificationAnchor, setNotificationAnchor, notifications, setNotifications }) => {
    const instance = Axios.getInstance()
    const openDrawer = Boolean(notificationAnchor)
    const userId = localStorage.getItem('userId')
    const API_URL = Endpoints.API_ENDPOINT
    const { readNotification } = useCommonStore()
    const navigate = useNavigate()
    const { GetTransferComplianceDetails, setNotification } = useCompStore()
    const transferCompDetailData = useCompStore(state => state.transferCompDetailData)
    const [complianceData, setComplianceData] = useState([])
    // const API_URL = Endpoints.API_ENDPOINT?.replace('/v1/core', '')
    // console.log('Endpoints.API_ENDPOINT', Endpoints.API_ENDPOINT)
    // useEffect(() => {
    //     const eventSource = new EventSource(`https://localhost:7193/api/Notification/${userId}/all`)

    //     eventSource.onmessage = (event) => {
    //         const newNotification = JSON.parse(event.data)
    //         setNotifications((prevNotifications) => [ newNotification, ...prevNotifications ])
    //     }

    //     return () => {
    //         eventSource.close()
    //     }
    // }, [])
    const [reassign, setReassign] = useState(false)

    useEffect(() => {
        if (transferCompDetailData?.length > 0) {
            const color = []
            const modifiedData = transferCompDetailData.map((item) => {
                for (let i = 0; i < item.roles.length; i++) {
                    const raciLet = {
                        color: '',
                        raciLetter: ''
                    }
                    switch (item.roles[i]) {
                        case 'Responsible':
                            raciLet.color = 'hsl(var(--light-blue))'
                            raciLet.raciLetter = 'R'
                            break
                        case 'Accountable':
                            raciLet.color = 'hsl(var(--light-red))'
                            raciLet.raciLetter = 'A'
                            break
                        case 'Consulted':
                            raciLet.color = 'hsl(var(--light-greenish))'
                            raciLet.raciLetter = 'C'
                            break
                        case 'Informed':
                            raciLet.color = 'hsl(var(--light-primary))'
                            raciLet.raciLetter = 'I'
                            break
                        default:
                            break
                    }
                    color.push(raciLet)
                }

                return {
                    title: item.complianceTitle,
                    dueBy: formatDate(item.dueBy),
                    chipRaciColor: color
                }
            })
            setComplianceData(modifiedData)
        }
    }, [transferCompDetailData])
    useEffect(() => {
        if (complianceData.length > 0) setReassign(true)
    }, [complianceData])

    const handleReadNotification = (data) => {
        readNotification([data?.id])
            .then((res) => {
                getAllNotification(userId).then((response) => {

                    setNotifications(response.data)
                    setNotificationAnchor(null)
                })
            })
            .catch((error) => {
                console.error('Error fetching notifications:', error)
            })
        if (data?.notificationKind === 7) {
            handleClose()
            GetTransferComplianceDetails(data.id)
            setNotification(data?.id)
        } else if (data?.notificationKind === 2) {
            // if (data?.message === 'Compliance has been successfully submitted and waiting for approval.') {
            //     navigate(`/GRC/manage-compliance/${data?.bodyType === 1 ? 'Mandate%20by%20Board' : 'Mandate%20by%20Law'}/${data?.govName}/${data?.compName}?bodyType=${data?.bodyType}&regulation=1&regulationId=1&complianceId=${data?.govId}&dueBy=${data?.dueBy}&view=calendar&status=1&matrix=1&cutoff=1`)
            // } else {
            //     navigate('/GRC/manage-compliance?bodyType=1&matrix=1&status=1&cutoff=1', { state: { isListView: true } })
            // }
            if (data?.message === 'Compliance has been successfully submitted and waiting for approval.') {
                const date = new Date(data?.dueBy)
                date.setDate(date.getDate() + 1)

                navigate(`/GRC/manage-compliance/${data?.bodyType === 1 ? 'Mandate%20by%20Board' : 'Mandate%20by%20Law'}/${data?.govName}/${data?.compName}?bodyType=${data?.bodyType}&regulation=1&regulationId=1&complianceId=${data?.govId}&dueBy=${date}&view=calendar&status=1&matrix=1&cutoff=1`)
            } else {

                navigate('/GRC/manage-compliance?bodyType=1&matrix=1&status=1&cutoff=1', { state: { isListView: true } })
            }
            // navigate('/GRC/manage-compliance?bodyType=1&matrix=1&status=1&cutoff=1', { state: { isListView: true } })
        } else if (data?.notificationKind === 3) {
            instance.get(API_URL + `/risk/ViewDetails?notificationId=${data?.id}&loginId=${userId}`)
                .then((res) => {
                    if (res?.data) {
                        navigate(`/GRC${RoutePath.RISK.URI}/${INITIATE}/${res?.data[0]?.referenceId}`, { state: { riskDetails: { riskId: res?.data[0]?.id } } })
                        setNotificationAnchor(null)
                    }
                })
        } else if (data?.notificationKind === 4) {
            instance.get(API_URL + `/issue/IssueViewDetails?notificationId=${data?.id}&loginId=${userId}`)
                .then((res) => {
                    if (res?.data) {
                        navigate(`/GRC${RoutePath.ISSUE.URI}/${ISSUE_TAB.ANALYZE_AND_PLAN}/${res?.data[0]?.referenceId}`, { state: { issueDetails: { issueId: res?.data[0]?.id } } })
                        setNotificationAnchor(null)
                    }
                })
        }
    }
    const handleNavigateNotifyDetails = (data) => {
        if (data?.notificationKind === 7) {
            handleClose()
            GetTransferComplianceDetails(data.id)
            setNotification(data?.id)
        } else if (data?.notificationKind === 3) {
            instance.get(API_URL + `/risk/ViewDetails?notificationId=${data?.id}&loginId=${userId}`)
                .then((res) => {
                    if (res?.data) {
                        navigate(`/GRC${RoutePath.RISK.URI}/${INITIATE}/${res?.data[0]?.referenceId}`, { state: { riskDetails: { riskId: res?.data[0]?.id } } })
                        setNotificationAnchor(null)
                    }
                })
        } else if (data?.notificationKind === 2) {

            if (data?.message === 'Compliance has been successfully submitted and waiting for approval.') {
                const date = new Date(data?.dueBy)
                date.setDate(date.getDate() + 1)

                navigate(`/GRC/manage-compliance/${data?.bodyType === 1 ? 'Mandate%20by%20Board' : 'Mandate%20by%20Law'}/${data?.govName}/${data?.compName}?bodyType=${data?.bodyType}&regulation=1&regulationId=1&complianceId=${data?.govId}&dueBy=${date}&view=calendar&status=1&matrix=1&cutoff=1`)
            } else {

                navigate('/GRC/manage-compliance?bodyType=1&matrix=1&status=1&cutoff=1', { state: { isListView: true } })
            }
            handleClose()
            // handleClose()
            // GetTransferComplianceDetails(data.id)
            // setNotification(data?.id)
        } else if (data?.notificationKind === 4) {
            instance.get(API_URL + `/issue/IssueViewDetails?notificationId=${data?.id}&loginId=${userId}`)
                .then((res) => {
                    if (res?.data) {
                        navigate(`/GRC${RoutePath.ISSUE.URI}/${ISSUE_TAB.ANALYZE_AND_PLAN}/${res?.data[0]?.referenceId}`, { state: { issueDetails: { issueId: res?.data[0]?.id } } })
                        setNotificationAnchor(null)
                    }
                })
        }

    }

    const handleMarkAllAsRead = () => {
        readNotification(notifications?.filter((filterData, _) => !filterData?.isRead)?.map((mapDt, _) => mapDt?.id))
            .then((res) => {
                const newNotifications = res?.json()
                if (JSON.stringify(newNotifications) !== JSON.stringify(notifications)) {
                    setNotifications(newNotifications)
                    setNotificationAnchor(null)
                }
            })
            .catch((error) => {
                console.error('Error fetching notifications:', error)
            })
    }
    const fetchNotifications = async () => {
        try {
            const response = await getAllNotification(userId)
            if (response?.status === 200) {
                const newNotifications = response.data
                if (JSON?.stringify(newNotifications) !== JSON?.stringify(notifications)) {
                    setNotifications(newNotifications)
                }
            }
        } catch (error) {
            console.error('Error fetching notifications:', error)
        }
    }

    useEffect(() => {
        fetchNotifications()
        const intervalId = setInterval(fetchNotifications, 3000)
        return () => clearInterval(intervalId)
    }, [notifications, useLoginStore.getState().accessToken])

    const handleClose = () => {
        setNotificationAnchor(null)
    }
    const [currentDate] = useState(new Date())
    return (
        <>

            <ReassignDialog viewType={'Acknowledge'} data={complianceData} activeCalendarDate={currentDate} isOpened={reassign} handleCloseModal={() => setReassign(false)} />
            <Drawer
                anchor="right"
                open={openDrawer}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: '26svw',
                        height: '100svh',
                        overflow: 'hidden'
                    }
                }}
            >
                <div className="w-full h-[inherit]">
                    <div className="flex flex-row w-full h-20 px-5 justify-between items-center border-b">
                        <p className="text-2xl font-semibold mx-1">Notifications</p>
                        <div className="flex flex-row items-center justify-between gap-6">
                            <p
                                onClick={() => {
                                    if (notifications?.some((n) => !n.isRead)) {
                                        handleMarkAllAsRead()
                                    }
                                }}
                                className={cn(
                                    'cursor-pointer text-md',
                                    notifications?.some((n) => !n.isRead) ? 'text-primary' : 'text-gray-400 cursor-not-allowed opacity-30'
                                )}
                                style={{ pointerEvents: notifications?.some((n) => !n.isRead) ? 'auto' : 'none' }}
                            >
                                Mark all as read
                            </p>
                            <p><IoCloseCircleOutline className="w-7 h-7 text-primary cursor-pointer" onClick={handleClose} /></p>
                        </div>
                    </div>
                    <Divider />
                    <div className="w-full h-[90svh] overflow-auto">
                        {notifications?.map((data, index) => (
                            <div
                                key={index}
                                onClick={() =>
                                    !data?.isRead ? handleReadNotification(data) : data?.notificationKind !== 1 && handleNavigateNotifyDetails(data)
                                }
                                className={cn(
                                    'flex cursor-pointer flex-row w-full border-b px-3 py-2 justify-between',
                                    !data?.isRead && 'bg-primary-foreground'
                                )}
                            >
                                <div className="w-12 my-2 flex flex-col items-center">
                                    {data?.notificationKind === 1 ? <GovernanceNavIcon width='30px' height='30px' isActive={true} /> : [2, 7, 8].includes(data?.notificationKind) ? <ComplainceNavIcon width='30px' height='30px' isActive={true} /> : <IoWarningOutline className="w-8 h-8 text-primary" />}
                                </div>
                                <div className="flex flex-col w-[85%] justify-between">
                                    <p className="text-sm py-1">{data?.message}</p>
                                    <span className={cn('flex flex-row', data?.notificationKind !== 1 ? 'justify-between' : 'justify-end')}>
                                        {(data?.notificationKind !== 1 && data.notificationKind !== 8) ? <p className="text-xs underline cursor-pointer text-primary">View Details</p> : <div></div>}
                                        <p className="text-xs text-gray-500">{formatDistToNow(data?.createdAt)} · {data?.notificationKind === 1 ? 'Governance' : [2, 7, 8].includes(data?.notificationKind) ? 'Compliance' : data.notificationKind === 4 ? 'Issue' : 'Risk'}</p>
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Drawer>
        </>

    )
}

Notification.propTypes = {
    notificationAnchor: PropTypes.object,
    setNotificationAnchor: PropTypes.func.isRequired,
    notifications: PropTypes.array.isRequired,
    setNotifications: PropTypes.func.isRequired
}

export default Notification
